// Change this url to match your local machine's ip address
// It is used for the native apps
// export default "http://192.168.178.116";
// export default "http://192.168.1.44";
export default "http://localhost";
